import NewUserRoute from './NewUserRoute';

export default NewUserRoute;
